export const AppLogo = () => {
  // TODO
  return <></>
}
